import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setDocuments, clearDocuments } from "../../../store/actions/documentActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllDocuments = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/document")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500) // anything under 500 handled in code, 500+ thrown as exception
      .then((response) => {
        if (response.status === 200) {
          dispatch(setDocuments(JSON.parse(response.text)))
        } else if (response.status === 401) {
          dispatch(clearDocuments);
          dispatch(authLogout);
        } else {
          dispatch(clearDocuments);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Document Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearDocuments);
      })
  }
}